import React from "react";
import Dashboard from "./pages/dashboard";
import PrivacyPolicy from "./pages/privacyPolicy";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ErrorPageSection from "./pages/errorPage";

function App() {
  return (
    <BrowserRouter>
      <div>
        <Switch>
          <Route exact path="/" render={(props) => <Dashboard />} />
          <Route path="/privacy" render={(props) => <PrivacyPolicy />} />
          <Route from="*" component={() => <ErrorPageSection/>} />
        </Switch>
        {/* <Dashboard /> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
